export default __webpack_public_path__ + "static/media/BYD T38423.cc6253e4.jpg";